import React from 'react';
import { Link } from 'react-router-dom';

const SCREENS = [
  {
    to: '/design-preview/import-review',
    title: 'Import review',
    desc: 'Two-column review with load summary, stop cards, and assignment panel with stepper.',
    tag: 'PDF workflow',
  },
  {
    to: '/design-preview/import-complete',
    title: 'Import complete',
    desc: 'Success state with stop summary, warnings, and clear next actions.',
    tag: 'Confirmation',
  },
  {
    to: '/design-preview/route-plan',
    title: 'Route plan detail',
    desc: 'Published plan with map chrome, stop table, and publish bar.',
    tag: 'Operations',
  },
];

const DesignPreviewHub = () => (
  <div className="dp-page">
    <header className="dp-page-header">
      <div>
        <p className="dp-eyebrow">Look & feel exploration</p>
        <h1 className="dp-title">Professional UI previews</h1>
        <p className="dp-lead">
          Suggested polish for sales demos and warehouse-manager walkthroughs. These screens use
          sample Steamboat load data and do not call the API.
        </p>
      </div>
    </header>

    <div className="dp-card-grid">
      {SCREENS.map((screen) => (
        <Link key={screen.to} to={screen.to} className="dp-hub-card">
          <span className="dp-badge dp-badge--neutral">{screen.tag}</span>
          <h2>{screen.title}</h2>
          <p>{screen.desc}</p>
          <span className="dp-hub-card__cta">Open preview →</span>
        </Link>
      ))}
    </div>

    <section className="dp-notes">
      <h2>Design principles applied</h2>
      <ul>
        <li>Clear hierarchy — eyebrow labels, page titles, and muted meta text</li>
        <li>Status chips instead of inline prose for load state</li>
        <li>Stop cards with type accent (pickup vs delivery)</li>
        <li>Sticky action bar on review screens</li>
        <li>Map + table layout for route plans</li>
        <li>Light sidebar shell (common in modern ops software)</li>
      </ul>
    </section>
  </div>
);

export default DesignPreviewHub;
